var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "vue-reviews" },
    [
      _vm.$mq === "lg" || _vm.$mq === "md"
        ? _c(
            "div",
            { staticClass: "reviews__slider", attrs: { id: "reviews-slider" } },
            [
              _c(
                "carousel-3d",
                {
                  attrs: {
                    perspective: 0,
                    width: 600,
                    height: 500,
                    space: 200,
                    autoplay: true,
                    "autoplay-timeout": 10000,
                    "autoplay-hover-pause": true,
                    clickable: true,
                    display: 3,
                    "controls-visible": true,
                    "controls-width": 30,
                    "controls-height": 30,
                  },
                },
                _vm._l(_vm.slide, function (model, key) {
                  return _c(
                    "slide",
                    { key: key, attrs: { index: key } },
                    [
                      _c("TextileSlide", {
                        key: key,
                        attrs: {
                          title: model.title,
                          image: model.image,
                          content: model.content,
                        },
                      }),
                    ],
                    1
                  )
                }),
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.$mq === "sm"
        ? _c(
            "swiper",
            {
              ref: "reviews-swiper",
              attrs: {
                id: "reviews-sliderPortrait",
                options: _vm.swiperOption,
              },
            },
            [
              _vm._l(_vm.slide, function (model, key) {
                return _c(
                  "swiper-slide",
                  { key: key, attrs: { index: key } },
                  [
                    _c("TextileSlide", {
                      key: key,
                      attrs: {
                        title: model.title,
                        image: model.image,
                        content: model.content,
                      },
                    }),
                  ],
                  1
                )
              }),
              _vm._v(" "),
              _c("div", {
                staticClass: "swiper-pagination",
                attrs: { slot: "pagination" },
                slot: "pagination",
              }),
            ],
            2
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }